import { useState } from "react";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import './Styles/App.css';
import Login from "./Pages/Login";
import UserContext from "./UserContext";
import { DefaultPlayer } from "./utils/Player";
import Edit from "./Pages/Edit";
import Overlay from "./Pages/Overlay";

const App = () => {
  const [ user, setUser ] = useState(DefaultPlayer);

  return (
    <UserContext.Provider value={ { user, setUser } }>
      <div>
        <BrowserRouter>
          <Routes>
            <Route index element={ <Login /> } />
            <Route path="edit/:id" element={ <Edit /> } />
            <Route path="overlay/:id" element={ <Overlay /> } />
          </Routes>
        </BrowserRouter>
      </div>
    </UserContext.Provider>
  );
};

export default App;